export default __webpack_public_path__ + "resources/icons/n112-35a8.png";